import { useState, useEffect } from 'react';

/**
 * Custom hook to check if the component is mounted.
 * Useful for preventing hydration issues with SSR.
 */
export const useMounted = () => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  return mounted;
};
